export const replaceTokens = (format, obj) => {
  if(!format || !obj)
    return format;

  const entries = Array.isArray(obj) ? obj : Object.entries(obj);

  const result = entries.reduce((message, [key, value]) => {
    const token =`{${key}}`
    return message.replace(new RegExp(token, "g"), value);
  }, format);

  return result;
}